export default __webpack_public_path__ + "static/media/goodbye.24451be4.png";